import {
  Box,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from "@mui/material"
import ContiSpecificButton from "components/ContiSpecificButton"
import { useState } from "react"
import { generatePath, useHistory } from "react-router-dom"
import {
  ateEanCode,
  basePath,
  contiEanCode,
  isAte,
  isMobile,
  isVDO,
  vdoEanCode,
} from "utils/Global"
import { default as Ate_vehicle_use } from "../../assets/images/ATE_Loyalty_Program_Werbetrailer_sec22.jpg"
import { default as Conti_vehicle_use } from "../../assets/images/CONTI_Loyalty_Program_Werbetrailer_sec22.jpg"
import { default as VDO_vehicle_use } from "../../assets/images/vdo_ean.png"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { InfoDialog as InfoDialogType } from "components/MappCodeCard/types"
import { useTranslation } from "react-i18next"
import { useProduct } from "contexts/ProductContext"
import eanScannerFrame from "../../assets/images/ean_scanner_frame.svg"
import eanScannerFrameATE from "../../assets/images/ean_scanner_frame_ate.svg"
import eanScannerFrameVDO from "../../assets/images/ean_scanner_frame_vdo.svg"
import Scanner from "components/Scanner"
import InfoDialog from "components/InfoDialog"
import { BarcodeFormat } from "react-qr-barcode-scanner"
import { fonts_VDO } from "themes/default/tokens"

export default function EanCodeCard() {
  const history = useHistory()
  const theme = useTheme()
  const { t } = useTranslation("app")
  const [showPlaceholder, setShowPlaceholder] = useState<boolean>(true)
  const [showInfo, setShowInfo] = useState(null)
  const [decodedText, setDecodedText] = useState("")
  const [data, setData] = useState("")
  const [error, setError] = useState("")
  const [typeCheck, setTypeCheck] = useState("vehicle")

  const { setProductCode } = useProduct()

  // EAN SCAN STATE
  const [show, setShow] = useState(false)
  const [scan, setScan] = useState(false)

  const redirectLocation = (gtin, type) => {
    setError("")
    // history.replace({
    //   pathname: "/scan",
    //   search: "ean=" + gtin,
    // })
    localStorage.setItem("data", gtin)
    history.push({
      pathname: generatePath("/tecdoc"),
      state: {
        gtin: gtin,
        type: type,
      },
    })
  }
  const eanCheck = (input) => {
    if (!/^\d{13}$/.test(input)) {
      setError(t("eanIncorrectLength"))
      return false
    } else {
      setError("")
    }

    // Calculate the check digit using the first 12 digits
    let checkDigit = 0
    for (let i = 0; i < 12; i += 2) {
      checkDigit += Number(input[i])
      checkDigit += Number(input[i + 1]) * 3
    }
    checkDigit = (10 - (checkDigit % 10)) % 10

    const isCorrectDigit = checkDigit === Number(input[12])
    !isCorrectDigit && setError(`${t("eanIncorrectCheck")} ${checkDigit}`)
    return isCorrectDigit
  }
  const handleChange = (e) => {
    setDecodedText(e.target.value)
    setData(e.target.value)
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      eanCheck(decodedText ? decodedText : data) &&
        redirectLocation(data, typeCheck)
    }
  }
  const onClickHandle = () => {
    eanCheck(decodedText ? decodedText : data) &&
      redirectLocation(data, typeCheck)
  }
  const handleScannerClick = () => {
    eanCheck(decodedText ? decodedText : data) &&
      redirectLocation(data, typeCheck)
  }

  const onUpdate = (err, result) => {
    if (!!result) {
      const text = result.getText ? result.getText() : result
      setData(text)
      if (eanCheck(text)) {
        setShow(false)
        setScan(false)
        setError("")
        redirectLocation(text, typeCheck)
      } else {
      }
    }
  }

  const closeScanner = () => {
    setScan(false)
    setShow(false)
    setShowPlaceholder(true)
    setProductCode("")
    setData("")
    setDecodedText("")
    setError("")
  }

  return (
    <>
      {/* CARD */}
      {!scan && (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "auto",
            overflow: "hidden",
            background: `url(${
              isAte
                ? basePath + Ate_vehicle_use
                : isVDO
                ? basePath + VDO_vehicle_use
                : basePath + Conti_vehicle_use
            }) center/cover`,
            "&:before": {
              content: "''",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              filter: "blur(5px)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              placeItems: "center",
              textAlign: "center",
              padding: "54px 16px",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Typography
              variant={isMobile ? "h6" : "h5"}
              fontWeight={isAte ? 400 : isVDO ? 500 : 600}
              fontSize={isMobile ? "20px" : "28px"}
              color={theme.tokens.color.conti_typo}
              marginBottom="20px"
            >
              {t("eanCodeCard.learnMoreAboutMyProduct")}
            </Typography>
            {isMobile && (
              <>
                <Typography
                  variant={"h4"}
                  fontWeight={isAte ? 400 : isVDO ? 500 : 600}
                  fontSize={"16px"}
                  color={theme.tokens.color.conti_typo}
                  sx={{
                    lineHeight: "1.6",
                  }}
                >
                  {t("eanCodeCard.scanEANCodeText")}
                </Typography>
                <Box
                  sx={{
                    margin: "16px auto",
                    display: "flex",
                    gap: "16px",
                    whiteSpace: "nowrap",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                    }}
                  >
                    <ContiSpecificButton
                      onClick={() => {
                        setTypeCheck("vehicle")
                        setScan(true)
                      }}
                      text={t("eanCodeCard.vehicleUses")}
                      isForwardIcon={false}
                      width="auto"
                    ></ContiSpecificButton>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                    }}
                  >
                    <ContiSpecificButton
                      onClick={() => {
                        setTypeCheck("technical")
                        setScan(true)
                      }}
                      text={t("eanCodeCard.techknicalInformation")}
                      isForwardIcon={false}
                      width="auto"
                    ></ContiSpecificButton>
                  </Box>
                </Box>
              </>
            )}
            {!isMobile && (
              <>
                <Box
                  sx={{
                    margin: "0 auto 20px auto",
                    color: "white",
                    display: "flex",
                    width: "100%",
                    whiteSpace: "nowrap",
                    flexDirection: isMobile ? "column" : "row",
                    borderBottom: "1px solid white",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      cursor: "pointer",
                      padding: "0 0 16px",
                      fontWeight: typeCheck === "vehicle" ? "bold" : "normal",
                      borderBottom: "2px solid",
                      borderColor:
                        typeCheck === "vehicle" ? "white" : "transparent",
                      fontFamily: isAte
                        ? "Etelka Light"
                        : isVDO
                        ? fonts_VDO.fontFamily
                        : "ContinentalStagSans-Light",
                    }}
                    onClick={() => {
                      if (isMobile) setScan(true)
                      setTypeCheck("vehicle")
                    }}
                  >
                    {t("eanCodeCard.vehicleUses")}
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      cursor: "pointer",
                      padding: "0 0 16px",
                      fontWeight: typeCheck === "technical" ? "bold" : "normal",
                      borderBottom: "2px solid",
                      borderColor:
                        typeCheck === "technical" ? "white" : "transparent",
                      fontFamily: isAte
                        ? "Etelka Light"
                        : isVDO
                        ? fonts_VDO.fontFamily
                        : "ContinentalStagSans-Light",
                    }}
                    onClick={() => {
                      if (isMobile) setScan(true)
                      setTypeCheck("technical")
                    }}
                  >
                    {t("eanCodeCard.techknicalInformation")}
                  </Box>
                </Box>
                <Typography
                  variant={"h4"}
                  fontWeight={isAte ? 400 : isVDO ? 500 : 600}
                  fontSize={"22px"}
                  color={theme.tokens.color.conti_typo}
                  sx={{}}
                >
                  {t("eanCodeCard.enterEANCode")}
                </Typography>
                <FormControl sx={{ margin: "16px auto 16px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexFlow: null,
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      fullWidth={true}
                      id="outlined-basic"
                      variant="outlined"
                      placeholder={showPlaceholder ? "4 006633 444729" : ""}
                      value={decodedText}
                      inputProps={{ min: 0, style: { textAlign: "center" } }}
                      InputProps={{
                        style: {
                          padding: "0",
                          margin: "0 auto",
                          borderRadius: "30px",
                          textAlign: "center",
                          fontFamily: isAte
                            ? "Etelka Light"
                            : isVDO
                            ? fonts_VDO.fontFamily
                            : "ContinentalStagSans-Light",
                          fontSize: "14px",
                          fontStyle: "italic",
                          letterSpacing: "3px",
                          width: "272px",
                          height: "44px",
                          backgroundColor: "#ffff",
                        },
                      }}
                      style={{}}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      onFocus={() => setShowPlaceholder(false)}
                      onBlur={() => setShowPlaceholder(true)}
                    />
                    <Box sx={{ margin: "0 20px 0 20px" }}>
                      <ContiSpecificButton
                        onClick={onClickHandle}
                        text={t("mappCodeCard.buttonText")}
                        isForwardIcon={true}
                        width="100px"
                      ></ContiSpecificButton>
                    </Box>
                  </Box>
                </FormControl>
                {error && (
                  <Typography
                    variant={"body2"}
                    fontWeight={700}
                    color="white"
                    fontSize="14px"
                    sx={{
                      padding: "8px",
                      backgroundColor: "#AA182A",
                      borderRadius: "8px",
                      margin: "0 auto 16px auto",
                    }}
                  >
                    {error}
                  </Typography>
                )}
              </>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
              }}
              color={theme.tokens.color.conti_typo}
              onClick={() => setShowInfo(InfoDialogType.EAN)}
            >
              <InfoOutlinedIcon
                sx={{ width: "24px", height: "24px" }}
                color="inherit"
              />
              <Typography
                color={theme.tokens.color.conti_typo}
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  marginLeft: "5px",
                }}
              >
                {t("eanCodeCard.whereCanIFindTheEANCode")}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}

      <InfoDialog
        showInfo={showInfo}
        setShowInfo={setShowInfo}
        title={t("eanCodeCard.whereCanIFindTheEANCode")}
      >
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: "300",
            lineHeight: "24px",
            marginBottom: "16px",
          }}
        >
          {t("eanCodeCard.EANCodeInfoProduct")}
        </Typography>

        <img
          src={isAte ? ateEanCode : isVDO ? vdoEanCode : contiEanCode}
          width="70%"
          height={"70%"}
          alt=""
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            padding: "10px 0px",
            maxWidth: "400px",
            marginBottom: "16px",
          }}
        ></img>
      </InfoDialog>

      {(show || scan) && (
        <Scanner
          frame={
            isAte
              ? basePath + eanScannerFrameATE
              : isVDO
              ? basePath + eanScannerFrameVDO
              : basePath + eanScannerFrame
          }
          formatScan={BarcodeFormat.EAN_13}
          placeholder="4 006633 444729"
          title={show ? t("scanCode") : t("scanEAN")}
          helperText={t("EANCodeInfo")}
          inputLabel={t("eanCodeCard.manualEnterEANCode")}
          error={error}
          showPlaceholder={showPlaceholder}
          productCode={decodedText}
          onClickHandle={handleScannerClick}
          closeScanner={closeScanner}
          handleChange={handleChange}
          onUpdate={onUpdate}
          setShowPlaceholder={setShowPlaceholder}
          setShowInfo={setShowInfo}
        />
      )}
    </>
  )
}
